import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoints } from './endpoints';
import { ExternalUrlGroupListWire } from './types';
import { ExternalUrlGroupsSearchModel } from './types-store';

export const api = {

  loadExternalUrlList: async (
    model: ExternalUrlGroupsSearchModel, startIndex: number, maxResults: number
  ): Promise<ExternalUrlGroupListWire> => {

    const response = await new RemoteAdminData(endpoints.searchExternalUrlGroups)
      .resource<Response>()
      .filter({
        displayNotSelected: true,
        ...(startIndex !== undefined && { startIndex }),
        ...(maxResults !== undefined && { maxResults })
      })
      .create(model, false);

    const json = await response.json();

    return json.data;
  },

  deleteExternalUrlGroup: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.deleteExternalUrlGroup)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  }
};
